import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ecp-order-validation',
  templateUrl: './order-validation.component.html',
  styleUrls: ['./order-validation.component.scss'],
})
export class OrderValidationComponent implements OnInit {
  @Input() orderDetails: any;
  constructor() {}

  ngOnInit(): void {}

  formatFileName(title: string) {
    return title.replace(/[_-]/g, ' ');
  }
}
